export const processContentConfig = {
  seg_00010003: [
    {
      label: '订单编号',
      key: '订单编号'
    },
    {
      label: '工资月份',
      key: '工资月份',
      type: 'date',
      format: 'YYYY年M月'
    },
    {
      label: '接单状态',
      key: '接单状态',
      type: 'status'
    },
  ],
  seg_00020001: [
    {
      label: '账单编号',
      key: '账单编号'
    },
    {
      label: '账单总额',
      key: '账单总额'
    },
    {
      label: '付款状态',
      key: '付款状态',
      type: 'status'
    },
  ],
  seg_00030003: [
    {
      label: '总/已发放金额',
      key: '总/已发放金额'
    },
    {
      label: '银行退票',
      key: '银行退票'
    },
    {
      label: '发薪状态',
      key: '发薪状态',
      type: 'status'
    },
  ],
  seg_00030004: [
    {
      label: '发票编号',
      key: '发票编号'
    },
    {
      label: '开票总额',
      key: '开票总额'
    },
    {
      label: '开票状态',
      key: '开票状态',
      type: 'status'
    },
  ],
  seg_00040001: [
    {
      label: '报税名义',
      key: '报税名义'
    },
    {
      label: '个税申缴金额',
      key: '个税申缴金额'
    },
    {
      label: '申缴状态',
      key: '申缴状态',
      type: 'status'
    },
  ],
  seg_00050001: [
    {
      label: '邮件工资条（发送/查看人数）',
      key: '邮件工资条（发送/查看人数）'
    },
    {
      label: '微信工资条（发送/查看人数）',
      key: '微信工资条（发送/查看人数）'
    },
    {
      label: '发放状态',
      key: '发放状态',
      type: 'status'
    },
  ],
}

export const timeLabelMap = {
  '待接单': '创建时间',
  '算薪中': '算薪时间',
  '已核算': '核算时间',
  '已付款': '付款时间',
  '已开票': '开票时间',
  '已发薪': '发薪时间',
  '已缴税': '申缴时间',
  '已发放': '发放时间',
}

export const processTextList = ['已退回', '待接单', '算薪中', '已核算', '待确认', '已付款', '待开票', '已开票', '已发薪', '已缴税', '已发放']
